import c from "styled-components";
import e from "../../../../utils/colors.js";
import { MenuColumnTheme as r } from "../../interfaces.js";
const u = c.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0;
  background-color: ${(o) => {
  const { $isActive: t, $colorScheme: l } = o;
  if (!t)
    return e.darkGrey;
  switch (l) {
    case r.BLUE_GREY:
      return e.blueGrey;
    case r.BLUE_GREY_75:
      return e.blueGrey75;
    case r.DARK_GREY:
    default:
      return e.darkGrey;
  }
}};
`;
export {
  u as MenuColumn
};
